import * as trace from 'owa-trace';
import changeIsLoading from '../../actions/changeIsLoading';
import clearIsDirty from '../../actions/clearIsDirty';
import createMailFolderTableQuery from 'mini-mail-list-actions/lib/utils/tables/createMailFolderTableQuery';
import FocusedInboxViewState from 'mini-options-store/lib/store/schema/FocusedInboxViewState';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import loadTableViewFromTableQuery from 'mini-mail-list-actions/lib/actions/tables/loadTableViewFromTableQuery';
import saveFocusedInboxOption from '../../actions/focusedInbox/saveFocusedInboxOption';
import updateUserOptions from '../../mutators/updateUserOptions';
import { getOptionsStore } from '../../store/Store';
import { IS_FOCUSED_INBOX_ENABLED } from '../../utils/constants';
import { orchestrator } from 'satcheljs';
import { setIsFocusedInboxCapableService } from '../../services/setIsFocusedInboxCapableService';
import updateUserConfiguration, {
    UserConfigurationSetting,
} from '../../services/updateUserConfiguration';

/**
 * Orchestrator is called when we save focused inbox option.
 * Sets isDirty to false.
 */
const saveFocusedInboxOptionOrchestrator = orchestrator(saveFocusedInboxOption, async () => {
    const userOptions = getUserConfiguration().UserOptions;
    const store = getOptionsStore();

    const { isFocusInboxEnabled } = store.activeViewState as FocusedInboxViewState;

    const serviceUpdates: UserConfigurationSetting[] = [];

    if (userOptions.IsFocusedInboxEnabled !== isFocusInboxEnabled) {
        serviceUpdates.push({
            propertyName: IS_FOCUSED_INBOX_ENABLED,
            propertyType: 'Boolean',
            propertyValue: `${isFocusInboxEnabled}`,
        });
    }

    if (serviceUpdates.length) {
        // start loading
        changeIsLoading(true);

        // update the value in client store
        updateUserOptions({ IsFocusedInboxEnabled: isFocusInboxEnabled });

        try {
            await updateUserConfiguration(serviceUpdates);

            // Make a request to set IsFocusedInboxCapable if IsFocusedInboxEnabled is set to true
            if (isFocusInboxEnabled) {
                setIsFocusedInboxCapableService();
            }

            const focusedViewFilter = isFocusInboxEnabled
                ? FocusedViewFilter.Focused
                : FocusedViewFilter.None;

            // Update the mail table to reflect the latest focusedViewFilter
            const tableQuery = createMailFolderTableQuery(
                folderNameToId('inbox'),
                focusedViewFilter,
                'All'
            );
            await loadTableViewFromTableQuery(tableQuery, null, true);

            clearIsDirty();
        } catch (error) {
            trace.errorThatWillCauseAlert(
                `saveFocusedInboxOptionOrchestrator: Unable to complete the network call. ${error}`
            );
        }
        changeIsLoading(false);
    }
});

export default saveFocusedInboxOptionOrchestrator;
